<div class="dialog-backdrop">
  <div class="dialog" role="dialog" aria-modal="true">
    <header class="dialog-header">
      <button class="close-btn" aria-label="Close" (click)="close()">
        <img src="../../../assets/icones/X.svg" alt="Close" />
      </button>
    </header>

    <section class="dialog-content">
      <h2>{{ 'quotations_and_orders.change_delivery_date.title' | translate }}</h2>

      <div class="summary">
        <strong>
          {{ combinedProducts.length }}
          {{ combinedProducts.length > 1
          ? ('common.products' | translate)
          : ('common.product' | translate)
          }}
        </strong>
        {{ 'quotations_and_orders.change_delivery_date.summary_product_missing' | translate }}
      </div>

      <div class="product-list">
        <div *ngFor="let p of combinedProducts" class="product-card">
          <div class="product-thumb">
            <img [src]="p.image && p.image.trim() !== '' ? getImageUrl(p.image) : placeholder"
              (error)="onImgError($event)" [alt]="p.product_name" />
          </div>

          <div class="product-meta">
            <div class="title">{{ p.product_name }}</div>
            <div class="sku">{{ p | productCode }}</div>
          </div>
        </div>
      </div>

      <div class="date-box" *ngIf="combinedProducts.length > 0">
        <div class="date-col">
          <div class="date-label">
            {{ 'quotations_and_orders.change_delivery_date.expected_delivery_date' | translate }}:
          </div>
          <div class="date-value">
            {{ data.acceptedDate | date:'dd/MM/yyyy' }}
          </div>
        </div>

        <div class="date-col">
          <div class="date-label">
            {{ 'quotations_and_orders.change_delivery_date.new_delivery_date' | translate }}:
          </div>
          <div class="new-date">{{ getNewShippingDate() }}</div>
        </div>
      </div>
    </section>

    <footer class="dialog-footer">
      <button class="btn remove" (click)="onRemoveClick()" [class.success]="isRemoved">
        <img *ngIf="!isRemoved" src="../../../assets/icones/Icone-B2B-Portal.svg" alt="Remove" />
        <img *ngIf="isRemoved" src="../../../assets/icones/icone-figma.svg" alt="Success" />

        <span *ngIf="!isRemoved">
          {{ 'quotations_and_orders.change_delivery_date.remove_from_order' | translate }}
        </span>
        <span *ngIf="isRemoved">
          {{ 'quotations_and_orders.change_delivery_date.items_removed' | translate }}
        </span>
      </button>

      <button class="btn keep-original" (click)="keepOriginalDate()">
        {{ 'quotations_and_orders.status_dialog.actions.keep_original_date' | translate }}
      </button>

      <button class="btn confirm" (click)="confirmNewDate()">
        {{ 'quotations_and_orders.change_delivery_date.confirm_new_date' | translate }}
      </button>
    </footer>
  </div>
</div>
